import React from 'react';
import styled from 'styled-components'

const LightenWrapper = styled.g`
   .st3{fill:none}
   .st3,
   .st4,
   .st5{stroke:#000;}
   .st5{fill:none;stroke-width:2}
   .st7{fill:#fff}
   .st8{stroke:#fff;stroke-width:3;}
   .st10,
   .st8{fill:none}
   .st15{opacity:.59}   
`

const LightenIcon = () => (
    <LightenWrapper>
        <circle className="icon-bg" cx="150" cy="150" r="150" />
        <g id="blender_1_">
            <g id="face_1_">
                <path id="faceback_1_" fill="#fff" stroke="#fff" d="M96.12 245.14c13.69-.78 108.92 8.25 108.16-6.56l-4-32.64-11.21-34.64c0-3.62-3.03-6.56-6.76-6.56h-69.29c-3.73 0-6.76 2.94-6.76 6.56l-11.83 33.64-5.07 33.64c.01 3.62 3.03 6.56 6.76 6.56z" />
                <path d="M124.59 208.18c-1.34 12.71 15.8 14.22 16.83 1.48 1.34-12.71-15.8-14.22-16.83-1.48z" className="st3" />
                <path d="M158.25 208.77c-1.34 12.71 15.8 14.22 16.83 1.48 1.34-12.72-15.8-14.22-16.83-1.48z" className="st3" />
                <path d="M135.38 212.44c-4.87 2.45-8.72-5.02-3.78-7.33 2.09-1.01 5.32-7.73 5.32-7.73s.55 14.04-1.54 15.06z" className="st4" />
                <path d="M170.29 210.67c-2.99 4.46-10.14-.21-7.01-4.58 1.3-1.88 9.39-7.35 9.39-7.35s-1.07 10.05-2.38 11.93z" className="st4" />
                <path d="M121.85 195.81c.73.79 1.46 1.58 2.2 2.38" className="st3" />
                <path d="M132.78 192.28c.08 1.11.15 2.22.23 3.32" className="st3" />
                <path d="M143.86 198.24c-.57.79-1.15 1.58-1.72 2.37" className="st3" />
                <path d="M155.07 199.6c1.22.31 2.29 1.11 2.91 2.17" className="st3" />
                <path d="M164.57 193.7c.16 1.11.33 2.21.49 3.32" className="st3" />
                <path d="M177.3 198.92c-.81.63-1.63 1.27-2.44 1.9" className="st3" />
                <path d="M161.35 180.41c4.46 6.11 11.86 10.1 19.56 10.56" className="st5" />
                <path d="M130.52 178.45c-2.86 7.03-8.55 12.93-15.58 16.18" className="st5" />
                <path stroke="#000" strokeWidth="4" d="M174.5 220.28c-3.14 7.24-8.21 13.87-15.13 17.95s-15.81 5.33-23.28 2.31c-3.76-1.52-7.01-4.18-9.26-7.47-1.65-2.42-4.69-8.29-2.65-10.91 8.41 3.62 15.9 6.57 25.36 6.26 8.89-.3 17.18-4.07 24.96-8.14z" />
                <path d="M126.71 234.71c12.34 2.52 25.11 2.37 38.23 0 0 0-8 8.63-21.44 8.63-8.78 0-16.79-8.63-16.79-8.63z" className="st7" />
                <path d="M123.16 220.9c19.1 10.09 33.72 9.04 54.23-2.59 0 0-6.43 14.67-28.5 14.67-16.54 0-25.73-12.08-25.73-12.08z" className="st7" />
            </g>
            <g id="blenderbody_1_">
                <g id="base_1_">
                    <path d="M96.31 262.92c33.24 1.97 66.47 1.97 99.71 0 2.33 0 4.23-1.84 4.23-4.1 3.9-8.96-101.74-2.05-103.93-4.1-5.46-.08-5.51 8.28-.01 8.2z" className="st8" />
                    <path d="M87.02 254.72c37.74 1.68 75.49 1.68 113.23 0 5.79-.03 5.8-13.64 0-13.67 0 0-7.61 7.11-57.46 6.29-56.49 1.09-56.5-13.44-60-.59-.39 3.22.86 8.1 4.23 7.97z" className="st8" />
                </g>
                <g id="pitcher_1_">
                    <path d="M226.81 133.4c13.3-27.86 47.54-88.29-10.81-72.4l-5.07 4.55s1.11 7.24 1.69 9.11c37.48-31.1 11.58 51.9-1.69 57.61-2.48 1.07-14.12 2.17-14.9 3.27-1.89 2.64-4.17 9.24-4.17 9.24 6.43-8.49 23.33-3.56 34.95-11.38z" className="st8" />
                    <path d="M106.45 165.25c13.13.62 79.63 5.11 82.81-3.41 0-1.89-2.27-3.41-5.07-3.41-26.19 1.05-52.1 1.07-77.74 0-6.55-.07-6.59 6.88 0 6.82z" className="st8" />
                    <path d="M106.45 158.42l77.74 1.14c16.49-31.04 26.81-62.12 28.73-93.25 0 2.47-123.37 2.27-138.58 0-15.21-1.14 6.85 9.23 7.39 14.69 1.82 18.43 15.26 57.15 24.72 77.42z" className="st8" />
                    <path d="M116.59 149.32c-7.86-11.91-20.87-48.21-21.97-62.55" className="st8" />
                    <path d="M93.78 86.78h21.12" className="st8" />
                    <path d="M96.06 98.26h10.39" className="st8" />
                    <path d="M99.73 107.36h10.4" className="st8" />
                    <path d="M102.97 116.46h8.45" className="st8" />
                    <path d="M106.64 125.56h10.39" className="st8" />
                    <path d="M109.73 132.38h6.76" className="st8" />
                    <path d="M113.4 141.48h15.21" className="st8" />
                    <path d="M117.58 149.44h10.4" className="st8" />
                </g>
                <g id="top_1_">
                    <path d="M127.96 53.01l38.98.02c7.27.45 8.32-1.96 5.78-5-1.81-10.21-35.53-6.09-44.75-5.03-3.19 0-5.78 2.24-5.78 5.01-3.57 3.17-.35 5.34 5.77 5z" className="st8" />
                    <path d="M214.11 59.53c1.94-9.31-137.06-9.6-135.94-.07-54.37 10.82 165.18 13.72 135.94.07z" className="st8" />
                </g>
            </g>
            <path id="arm_1_" fill="none" stroke="#fff" strokeWidth="5" d="M194.72 216.83c15.2-8.92 33.02-11.22 50.58-6.53 1.61-19.58 1.92-39.44 3.53-59.02 3.52-.38 6.87-1.78 9.76-4.1" />
        </g>
        <linearGradient id="lamp-grad" x1="27.4455" x2="66.4235" y1="80.0913" y2="50.6092" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#7ac943" />
            <stop offset="1" stopColor="#2a4418" />
        </linearGradient>
        <linearGradient id="light-grad" x1="253.1737" x2="113.8924" y1="332.1808" y2="117.7065" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopOpacity="0" />
            <stop offset="1" stopColor="#fcee21" stopOpacity=".7" />
        </linearGradient>
        <path fill="url(#light-grad)" d="M289.15 206.09L71.83 39.25 55.45 54.19 24.13 83.28l45.42 111.47L111.1 294.9c10.89 2.92 22.27 4.64 33.99 5.02l9.68.01c60.95-1.92 112.73-40.18 134.38-93.84z" />
        <path d="M72.02 39.08L289.43 205.4c5.41-13.6 8.88-28.17 10.09-43.39V138C293.95 67.61 239.8 10.92 170.6 1.41h-41.2c-25.71 3.53-49.34 13.57-69.18 28.41l11.9 9.17-.1.09z" className="st15" />
        <path d="M23.53 83.83l.6-.55-.15-.38-.62.57-3.2-8.59C8.65 94.74 1.56 117.48.25 141.75l.05 17.31c3.88 65.07 49.23 118.95 109.99 135.6l-40.72-99.92L23.53 83.83z" className="st15" />
        <path d="M274.92 120.08h5.34v74.91h-5.34z" className="st7" />
        <path d="M274.73 156.38l-15.4-13.76 5.95-3.58 15.4 13.76z" className="st7" />
        <path fill="url(#lamp-grad)" d="M88.67 52.13l-28.6-22.19C44.1 41.92 29.61 58.02 19.47 75.32l11.5 27.58 57.7-50.77z" />

    </LightenWrapper>)

export default LightenIcon;
/*

*/